<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Import Manager</h4>
  <button
    type="button"
    class="btn btn-link p-0 border-0"
    aria-label="Close"
    (click)="cancel()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body p-2">
    <div class="d-flex flex-column gap-3 p-3">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title">Import Products</h5>
                <p class="card-text">Import additional products into your range from a file.</p>
                <button class="btn btn-primary w-100" (click)="importProducts()">Import Products</button>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h5 class="card-title">Refresh Product Data</h5>
                <p class="card-text">Update existing products by selecting which fields to refresh from source data.</p>
                <button class="btn btn-primary w-100" (click)="refreshProducts()">Refresh Product Data</button>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
